var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-webp #blueRow[data-v-ee6aaa08]{padding:0;min-height:445px;background:url(" + escape(require("../../assets/images/backgrounds/blue.jpg")) + ") no-repeat top;background-attachment:fixed;background-size:cover;width:100%;color:#fff}.webp #blueRow[data-v-ee6aaa08]{padding:0;min-height:445px;background:url(" + escape(require("../../assets/images/backgrounds/blue.webp")) + ") no-repeat top;background-attachment:fixed;background-size:cover;width:100%;color:#fff}", ""]);

// exports
